(function () {
    'use strict';

    angular
        .module('app')
        .controller('tsunRecommendDocController', tsunRecommendDocController);

    function tsunRecommendDocController(trainingInnerService,$location,$q) {
        var vm = this;
        //==Main==
        init();
        //========
        function init() {
            dataInit();
            logicInit();
        }
        function dataInit() {
            vm.data = {
                innerHtml : '',//........內容顯示的HTML
            };
            vm.view = {
                
            };
        }
        function logicInit() {
            return loadData().then(function () {
            });
        }

        function loadData() {
            var recommendHtml = sessionStorage.getItem("recommendHTML");
            return $q.when(recommendHtml).then(function(data){
                vm.data.innerHtml = data;
            });
        }
        
    }
})();